import "../styles/buttonGB.css"
export const ButtonGB = (props) => {
    const { type = "button", className = props.color === "success" ? "buttonGB-success" : "buttonGB" } = props;
    return (
        <div className="flex justify-center">
            <button type={type} className={`${className} radioButtonGroup__item`} onClick={props.onClick}>{props.text}</button>
        </div>
    )
}